import { render, staticRenderFns } from "./OnlineScheduling.vue?vue&type=template&id=058fa0fa&"
import script from "./OnlineScheduling.vue?vue&type=script&lang=js&"
export * from "./OnlineScheduling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports